import React from "react";
import ReactECharts from "echarts-for-react";



const BarChart = ({ data }) => {



  const shortenXAxisLabel = (value) => {
    
    const labelMap = {
      "ServiceOps Narrative": "SvcOps",
      "AIOps & Observability Narrative": "AIOps & Obs.",
      "One BMC Narrative - Mainframe & Distributed": "One BMC ",
      "End-to-End Observability Narrative with Live App": "E2E Obs.",
      "BMC Helix Platform Demo for Executives (CXO Dashboard Narrative)": "CXO Dash.",
      "Customer Service Management - CSM": "CSM",
      "Change Management DevOps meets ITIL": "Chg Mgmt",
      "Service Predictions": "Svc Pred.",
      "Security Incident Handling": "SIH",
      "Policy Based Clustering (Network Alerts)": "Policy Clustering",
      "The Complete Banking Story": "Complete Banking",
      "Agentic AI Driven HRSM": "HRSM",
      "HelixGPT - Vulnerability Resolver": "Vuln Ops"
    };

    // Return the mapped value or the original value if not in labelMap
    return labelMap[value] || value;
  };








  const options = {
    grid: {
      left: "10%",
      right: "10%",
      top: "20%",
      bottom: "25%",
    },
    tooltip: {
      trigger: "axis",
      axisPointer: {
        type: "shadow", // 'line' or 'shadow'
      },
      formatter: function (params) {
        const param = params[0]; // Since we have only one series
        return `${param.name}<br/>Value: ${param.value}`;
      },
    },
    xAxis: {
      type: "category",
      data: data.xData,
      axisLabel: {
        fontSize: 8,
        rotate: 45,
        color: "#102A43",
        formatter: (value) => shortenXAxisLabel(value),
      },
    },
    yAxis: {
      type: "value",
    },

    dataZoom: [
      {
        type: "slider",
        xAxisIndex: 0,
        start: 0,
        end: 30, // Show the first 100% initially
        zoomLock: true,
        moveOnMouseMove: false,
        showDetail: false,
        showDataShadow: true,
        realtime: true,
        brushSelect: false,
        bottom: "10px", // Move the slider up to avoid overlapping
        handleSize: "100%", // Make the handle larger for better UX
        handleStyle: {
          color: "#85D7FF", // Light blue handle color
          borderWidth: 1,
          borderColor: "#5AB1F6", // Slightly darker blue border
        },
        fillerColor: "rgba(133, 215, 255, 0.2)", // Transparent light blue background
        borderColor: "transparent", // Remove the border for a cleaner look
        textStyle: {
          color: "transparent", // Hide text
        },
      },
    ],



    series: [
      {
        data: data.yData,
        type: "bar",
        itemStyle: {
          color: "#85D7FF", // Light blue color
        },
      },
    ],
  };

  return (
    <div className="chart-container">
      <ReactECharts
        option={options}
        style={{ height: "450px", width: "100%", marginTop: "-80px" }}
      />
    </div>
  );
};

export default BarChart;
